import { createAction } from 'redux-actions';
export const SET_PASSENGERS_CONFIG = 'SET_PASSENGERS_CONFIG';
export const setPassengersConfig = createAction(SET_PASSENGERS_CONFIG);
